import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { REVIEW_FEATURES } from '../review-mode-side-panel/constants';
import type { FeedbackQuestionnaireConfig } from '../types/types';
import type { TaskModeT } from './constants';
import { TASK_MODE } from './constants';
import type { TaskStateInfoT } from './types';
export const taskStateInfoAtom = atom<TaskStateInfoT>();
export const hasRequiredTaskModeAtomFamily = atomFamily((requiredTaskMode: TaskModeT) => atom<boolean>(get => {
  const taskStateInfo = get(taskStateInfoAtom);
  return taskStateInfo?.taskModes.includes(requiredTaskMode) ?? false;
}));
export const isReviewModeAtom = hasRequiredTaskModeAtomFamily(TASK_MODE.REVIEW);
export const isRejectTaskFeatureEnabledAtom = atom<boolean>(get => {
  const taskStateInfo = get(taskStateInfoAtom);
  return taskStateInfo?.reviewFeatureConfig?.[REVIEW_FEATURES.ACCEPT_REJECT_TASK] ?? false;
});
export const collectFeedbackQuestionnaireAtom = atom<FeedbackQuestionnaireConfig | undefined>(get => {
  const taskStateInfo = get(taskStateInfoAtom);
  return taskStateInfo?.reviewFeatureData?.[REVIEW_FEATURES.ACCEPT_REJECT_TASK]?.feedbackQuestionnaire;
});
export const isCollectFeedbackFeatureEnabledAtom = atom<boolean>(get => {
  const taskStateInfo = get(taskStateInfoAtom);
  const hasCommentsFeedback = taskStateInfo?.reviewFeatureConfig?.[REVIEW_FEATURES.ENABLE_COMMENTS_FEEDBACK] ?? false;
  const hasQuestionnaire = !!get(collectFeedbackQuestionnaireAtom);
  return hasCommentsFeedback || hasQuestionnaire;
});